import {
  CircleArrowDown,
  CircleArrowUp,
  SlidersHorizontal,
} from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useThemesFilterStore } from "../stores";

const ThemesFilterComponent = () => {
  const { t } = useTranslation();
  const { statusFilter, ordering, setStatusFilter, setOrdering } =
    useThemesFilterStore();

  const hasActiveFilters = statusFilter !== null || ordering !== null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          size="icon"
          className="relative bg-primary/10 text-primary hover:bg-primary/20"
        >
          <SlidersHorizontal />
          {hasActiveFilters && (
            <span className="absolute -top-1 -right-1 size-2.5 rounded-full bg-primary" />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="-translate-x-3 sm:-translate-x-6">
        <DropdownMenuGroup>
          <DropdownMenuLabel>{t("keys.filter_by.status")}</DropdownMenuLabel>
          <DropdownMenuCheckboxItem
            checked={statusFilter === "active"}
            onCheckedChange={() =>
              setStatusFilter(statusFilter === "active" ? null : "active")
            }
          >
            <Badge variant="success">{t("keys.active")}</Badge>
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={statusFilter === "inactive"}
            onCheckedChange={() =>
              setStatusFilter(statusFilter === "inactive" ? null : "inactive")
            }
          >
            <Badge variant="destructive">{t("keys.desactivated")}</Badge>
          </DropdownMenuCheckboxItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuLabel>{t("keys.filter_by.date")}</DropdownMenuLabel>
          <DropdownMenuCheckboxItem
            checked={ordering === "created_at"}
            onCheckedChange={() =>
              setOrdering(ordering === "created_at" ? null : "created_at")
            }
          >
            <CircleArrowUp className="text-gray-500" />
            Asc
          </DropdownMenuCheckboxItem>
          <DropdownMenuCheckboxItem
            checked={ordering === "-created_at"}
            onCheckedChange={() =>
              setOrdering(ordering === "-created_at" ? null : "-created_at")
            }
          >
            <CircleArrowDown className="text-gray-500" />
            Desc
          </DropdownMenuCheckboxItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ThemesFilterComponent;
